import { render, staticRenderFns } from "./PreviewMultiChoiceQuestion.vue?vue&type=template&id=25531b2f"
import script from "./PreviewMultiChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./PreviewMultiChoiceQuestion.vue?vue&type=script&lang=js"
import style0 from "./PreviewMultiChoiceQuestion.vue?vue&type=style&index=0&id=25531b2f&prod&lang=css"
import style1 from "./PreviewMultiChoiceQuestion.vue?vue&type=style&index=1&id=25531b2f&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports